import React, { Suspense } from "react";

import Loading from "ui/Loading";
import LoadingErrorBoundary from "ui/LoadingErrorBoundary";

function SuspenseBoundary({ children }: { children: React.ReactNode }) {
  return (
    <LoadingErrorBoundary>
      <Suspense fallback={<Loading />}>{children}</Suspense>
    </LoadingErrorBoundary>
  );
}

export default SuspenseBoundary;
